import { useMemo } from "react";
import {
	buildRoleColorResolver,
	buildRoleGroupColorResolver,
	type RoleColorPins,
	type RoleColorResolver,
	type RoleGroupColorResolver,
} from "../utils/categoricalColors";
import { useRoleColorPins } from "./useUserSettings";

const NO_PINS: RoleColorPins = {};

/** Saved role colours for the chosen department. */
export const useRoleColors = (): RoleColorResolver => useRoleColorResolver(undefined);

/** The same resolver with pending pins for the Appearance preview. */
export const useRoleColorResolver = (pendingPins: RoleColorPins | undefined): RoleColorResolver => {
	const savedPins = useRoleColorPins();
	// DEFAULT: role pins are absent during the settings fetch; the default colours show meanwhile.
	const pins = pendingPins ?? savedPins ?? NO_PINS;
	return useMemo(() => buildRoleColorResolver(pins), [pins]);
};

/** Role-group colours follow the pinned colour when a group represents one role. */
export const useRoleGroupColors = (): RoleGroupColorResolver => {
	const savedPins = useRoleColorPins();
	// DEFAULT: retain default group colours while settings load.
	const pins = savedPins ?? NO_PINS;
	return useMemo(() => buildRoleGroupColorResolver(pins), [pins]);
};
